import { PRINCIPAL_ROUTE_NAME } from "@router/principal";

const en = {
  common: {
    preview: "Preview",
    continue: "Continue",
    next: "Next",
    previous: "Previous",
    complete: "Complete",
    skip: "Skip",
    saveChanges: "Save changes",
    save: "Save",
    upload: "Upload image",
    uploadVideo: "Upload video",
    loading: "Loading",
    back: "Back",
    cancel: "Cancel",
    delete: "Delete",
    close: "Close",
    twentyMinutes: "20 min",
    fiftyMinutes: "50 min",
    resetPasswordError: "Error occurred while attempting to reset password",
    notFoundEmailError:
      "Configured or registered user with this email not found",
    email: "Email address",
    password: "Password",
    passwordConfirm: "Confirm your password",
    corporateEmail: "Please enter your corporate email address",
    anyEmail: "Enter your corporate email address",
    today: "Today",
    scheduleSession: "Schedule a session",
    invalidEmail: "Invalid email address",
    invalidPasswordLength: "8 characters long",
    invalidPasswordMatch: "1 uppercase & 1 lowercase character & 1 number",
    invalidPasswordConfirm: "Passwords don’t match",
    requiredField: "This field is required",
    no: "No",
    checkSearch: "Add a new one or check if the search is correct",
    noFound: "No {{name}} found",
    switchAccountError:
      "Error occurred while attempting to switch organization",
    dragNDrop: "Drag and drop some files here, or click to select files",
    continueWithCode: "Continue with code",
    continueWithoutCode: "Skip",
    areYouSure: "Are you sure?",
    yes: "Yes",
    create: "Create",
    continue: "Continue",
    keywordSearch: "Search",
    watchHelloVideo: "Watch greeting video",
    helloVideoTitle: "Greeting video",
    profileImage: "Profile image",
    aboutMeVideo: "Greeting video",
    notes: "Notes",
    add: "Add",
    color: "Color",
    min: "min",
    send: "Send",
    selectStatus: "Select a status",
    showMore: "Show more",
    showLess: "Show less",
    download: "Download",
    downloadQrAsSvg: "Click and download QR as SVG",
    copied: "Copied",
    copyError: "Error while copying",
    ok: "Okay",
    updateAvailable: "Update available",
    updateAvailableDescription:
      "A new version of Allbry is available. Please refresh the page to get the latest version.",
    refresh: "Refresh",
  },
  modal: {
    sizeLimit: {
      title: "File size limit has been reached",
      content:
        "File is too big for the upload, the limit is {{sizeLimit}}. Please, choose another one.",
    },
    fileType: {
      title: "Invalid file type",
      content: "You are only able to use images",
    },
    akkImage: {
      akkImage: "AAC image",
      customImage: "Custom image",
      uploadImage: "Select image",
    },
    endDate: {
      title: "End date",
      content: "Please select the end date",
    },
  },
  mobile: {
    notAvailable: "Allbry web version is not available on mobile",
    availableInLandscape:
      "Allbry web version is only available in landscape mode",
    pleaseUseLinks: "Please, download our mobile app using the link below",
    pleaseUseLinksLandscape:
      "You can download our mobile app using the link below",
    appStore: "App Store",
    googlePlay: "Google Play",
  },
  introduction: {
    getSupport: "Get support from Allbry, wherever you are",
    chat: {
      student: "Jamie",
      counsellor: "Margo",
      messages: {
        first: "She said I was lazy!",
        second: "I have school, dance class, the horses and tutoring!",
        third: "She doesn't get me... 😔",
        fourth: "Oh dear, let's talk!",
      },
    },
  },
  auth: {
    login: {
      withEmail: "Enter your email address",
      codeStepTitle: "Did you receive an registration code?",
      loginSuccess: "You have logged in successfully",
      enterPassword: "Enter your password",
      codeStepSubtitle:
        "In some cases you need a registration code to sign up. If you received one, please enter it below. If not, just press skip.",
      codeInput: "Registration code",
      codeInputHint: "Please enter your registration code if you received one",
      createPass: "Create your password",
      terms: "I have read, understood and hereby approve of Allbrys ",
      termsLink: "terms of use",
      paymentTitle: "Renew your subscription",
      paymentDescription:
        "Allbry costs {{price}} {{currency}} every month. The subscription is active until you cancel it.",
    },
    logout: {
      logoutSuccess: "You have logged out successfully",
    },
    signUpConsumer: {
      terms: "I have read, understood and hereby approve of Allbrys ",
      termsLink: "terms of use",
      startJourney: "Start your journey with Allbry today",
      withOrganization: "Sign up with Organization",
      withEmail: "Sign up with Email",
      signUp: "Sign up",
      createPass: "Create your password",
      haveAccount: "Already have an account?",
      logIn: "Log in",
      connectedOrganization: "Your account belongs to ",
      aboutYourSelfHeader: "Choose your username",
      aboutYourSelfDescription1:
        "Choose the name you want to be visible to the counsellor or advisor.",
      aboutYourSelfDescription2:
        "We do not disclose your personal information to third parties.",
      paymentTitle: "Create your subscription",
      paymentDescription:
        "Allbry costs {{price}} {{currency}} every month. The subscription is active until you cancel it.",
      paymentDescriptionSuccess:
        "Congratulations! Your account is now successfully created and your subscription is active until you cancel it.",
      successTitle: "Congratulations!",
      successDescription:
        "Welcome to Allbry! We are here to support, motivate and guide you.",
      klarnaLoadingError:
        "Something went wrong when trying to load the payment widget, please try again",
      klarnaOrderError:
        "Something went wrong when trying to complete the payment, please try again",
    },
    forgot: {
      checkStep: "Check your email",
      weJustSent: "We've just sent",
      resetPassLink: "reset password link",
      followInstructions:
        "to your email. Please check your inbox and follow the instructions.",
      enterEmail: "Enter your email",
      createNewPass: "Create new password",
    },
    registrationError: "User registration failed",
    signInError: "Wrong email or password",
    invalidPassword: "Invalid password",
    forgotPassword: "Forgot password?",
    externalJoin: {
      title: "Did you receive an meeting code?",
      description:
        "If you received a meeting code, please enter it below to get started.",
      placeholder: "Enter your meeting code",
      help: "If you don't have a meeting code, please contact your organizer.",
      invitationMessage: "You have been invited to a meeting in Allbry",
      invitationDescription:
        "You have been invited to a meeting through Allbry by {{counselorName}}",
    },
  },
  navbar: {
    switch: "Set yourself as",
    toOffline: "Offline",
    toOnline: "Online",
    appointments: {
      title: "Appointments",
      text: "Schedule meetings with student health staff to get more qualified help",
    },
    messages: {
      title: "Messages",
      text: "Communicate with student health staff and get help anytime",
    },
    students: {
      title: "Students",
    },
    reports: {
      title: "Reports",
    },
    organizations: {
      title: "Organizations",
    },
    statistics: {
      title: "Statistics",
    },
    profile: "Profile",
    settings: {
      title: "Settings",
    },
    logOut: "Log out",
    [PRINCIPAL_ROUTE_NAME.ORGANIZATION]: {
      title: "organization",
    },
    [PRINCIPAL_ROUTE_NAME.STATISTICS]: {
      title: "statistics",
    },
    [PRINCIPAL_ROUTE_NAME.USERS]: {
      title: "users",
    },
    counsellors: {
      title: "Student health staff",
    },
    ftpDataCollection: {
      title: "FTP Data Collection",
    },
    dataMigration: {
      title: "Data Migration",
    },
    configForm: {
      title: "Config Form",
    },
    notifications: {
      title: "Notifications",
    },
    superActions: {
      title: "Super Actions",
    },
    checkInsAndSurveys: {
      title: "CheckIns and Surveys",
    },
    config: {
      title: "Template",
    },
    broadcastMessages: {
      title: "Broadcast Messages",
    },
    customReports: {
      title: "Reports",
    },
  },
  notFound: {
    code: "404",
    text: "Not Found",
  },
  settings: {
    title: "Settings",
    billing: {
      title: "Billing details",
      activeStatus:
        'Your subscription is <b class="text-green">Active</b> and you next billing will occur on <b>{{date}}</b>',
      inactiveStatus:
        'Your subscription is <b  class="text-red">Inactive</b>, but you account is available until <b>{{date}}</b>',
      manageSubBtn: "Manage subscription",
      cancelSubBtn: "Cancel subscription",
      manageSub: "Manage subscription",
      cancelSub: "Cancel subscription",
      cancelSubSubtitle:
        "Are you sure you want to leave us? We are always here for support. <br>You are of course welcome back anytime! Your account will remain active until {{date}}, then we say goodbye.",
      confirmCancel: "Confirm cancellation",
    },
    anonymous: {
      title: "Anonymous mode",
      description:
        "Your organization allows you to be anonymous. Your name and profile image will be hidden from other users.",
    },
    allowEmailNotification: {
      title: "Email notification",
      description: "You can turn off email notifications from Allbry",
    },
    calendarSync: {
      title: "External calendar sync",
      description: "Activate external calendar sync for appointments",
      freeDescription:
        "Activate external calendar sync for added available time",
      freeNote:
        "Note: Most of the time everything is added automatically, but if not, follow the instructions in the email sent to you when adding available times.",
    },
    dataReset: {
      recurrentReset: {
        title: "Recurrent data reset",
        disabledResetParagraph:
          "Enable recurrent data reset to clear data automatically. Please note that data reset affects chats, appointments, notes.",
        enabledResetParagraph:
          "Estimated date for the next reset is {{date}}. Please note that data reset affect chats, appointments, notes.",
        intervalLabel: "Interval",
        intervals: {
          eachMonth: "Each month",
          eachThreeMonths: "Each 3 months",
          eachSixMonths: "Each 6 months",
        },
        errorGettingResetState:
          "Error while getting current recurrent jobs state",
        errorSwitchingResetState: "Error while changing recurrent jobs state",
        errorIntervalChange: "Error while changing reset interval",
        successIntervalChange: "New reset interval has been set",
      },
      manualReset: {
        title: "Reset data now",
        paragraph:
          "Please note that data reset affects chats, appointments, notes.",
        resetButton: "Clear all data",
        resetSuccess: "The data has been cleared",
        resetFailure: "Error while resetting data",
        resetModal: {
          title: "Clear all data",
          paragraph:
            "Are you sure you want to reset all information in chats, appointments, notes?",
          yes: "Yes",
          no: "No",
        },
      },
    },
    policy: {
      title: "Integrity Policy",
      description: {
        firstPart:
          "Being fully aware that our work as consultants and engineers is critical to the achievement of a sustainable development of the society and the environment, we have designed and implemented a range of measures aiming at making our ethical conduct one of IRD Engineering main characteristics.",
        secondPart:
          "All these, and any future measures, are and will be incorporated in our Integrated Management System, which represents the official Company policy and procedures to ensure that the Company's services are carried out at a high professional level, consistent with the highest international standards in terms of quality assurance, environmental sustainability and worker's health and safety.",
      },
      policyCopy:
        "A copy of our Code of Ethics and Integrity Policy can be found",
      hereLink: "here",
    },
    language: {
      title: "Language",
    },
    changePassword: "Change Password",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmPassword: "Confirm New Password",
    passwordChanged: "Password Changed Successfully",
    unavailable: {
      title: "Unavailable",
      description: "Enter the field below to set your unavailable message",
      success: "Your unavailable massage has been updated successfully",
      unavailableText: "Write your unavailable text here",
      anywaySendMessage:
        "Allow the student to continue sending messages even if you are unavailable.",
    },
  },
  profile: {
    personProfile: "{{type}}'s profile",
    personProfileName: "{{person}}s profile",
    overview: "Profile Overview",
    edit: {
      title: "Edit profile",
      restriction: "Only owners and admins can edit.",
      gender: {
        male: "Male",
        female: "Female",
        other: "Other",
        private: "Do not wish to say",
      },
      about: "About",
      changesSaved: "Changes Saved",
    },
    personalInfo: "PERSONAL INFORMATION",
    about: "About me",
    name: "Name",
    birthday: "Date of Birth",
    fullBirthday: "{{birthday}} ({{fullYears}} years)",
    appointments: "APPOINTMENTS",
    noAppointments: "No appointments found for this category",
    gender: "Gender",
    age: "Age",
    email: "Email",
    lastNote: "{{person}}'s last note will be placed here.",
    parentAccountID: "Parent account ID",
    noParentIfEmpty: "No parent if empty",
    secretIdentity: "Protected identity",
  },
  appointments: {
    title: "Appointment",
    session: {
      today: "Join Now",
      future: "Cancel or Reschedule",
      completed: "Book another session",
      cancelled: "Book another session",
      cancel: "Cancel",
    },
    status: {
      upcoming: "Upcoming",
      completed: "Completed",
      cancelled: "Cancelled",
      pending: "Pending confirmation from you",
      unanswered: "Pending confirmation by {{name}}",
      active: "Accepted",
    },
    action: {
      accept: "Accept",
      reschedule: "Reschedule",
      deny: "Deny",
      goToAppointment: "Go to appointment",
    },
    unansweredDialog: {
      title: "You have unanswered appointment requests",
      continueBtn: "Continue later",
    },
    booking: {
      title: {
        booking: "Booking",
        reschedule: "Reschedule",
      },
      schedule: "Schedule",
      chooseUser: "Choose users",
      selectUser: "Select user",
      chooseStudent: "Choose student",
      selectStudent: "Select student",
      sessionDuration: "Choose session duration",
      sessionTime: "Choose session time",
      success: "Success",
      successText:
        "The session was successfully {{action}}! Now you can check your session in upcoming appointments",
      successBooked: "booked",
      successRescheduled: "rescheduled",
      back: "Back to appointments",
      chooseStudentModal: "Choose student",
      chooseUserModal: "Choose users",
      done: "Done",
      chooseCounsellor: "Choose student health staff",
      chooseCounsellorModal: "Choose student health staff",
      selectCounsellor: "Select student health staff",
      searchStudents: "Search students",
      noTimeSlots: "No available time slots",
      recommendedSlotsMassage:
        "No available slots, choose a different date or select on of the recommended slots below",
      recommendedSlots: "Recommended slots",
      custom: "Custom time",
      startTime: "Start time",
      endTime: "End time",
      video: "Video",
      students: "Students",
      counsellors: "Student health staff",
      search: {
        student: "Search student",
        counsellor: "Search health staff",
      },
      notFound: {
        student: "No student found",
        counsellor: "No student health staff found",
      },
      selectExternal: "Add external participant",
      name: "Name",
      number: "Phone number",
      email: "Email",
    },
    detail: {
      scheduleInfoCancelOrReschedule:
        "The session is scheduled on {{date}} at {{time}}. You're able to cancel or reschedule it.",
      scheduleInfoBookAnother:
        "The session is scheduled on {{date}} at {{start}} - {{end}}. You are able to book another one.",
      reschedule: "Reschedule",
      cancel: "Cancel Appointment",
      areYouSure: "Are you sure you want to cancel your session?",
      yes: "Yes, Cancel",
      cancelled: "The session was cancelled",
      sessionDetails: "Session details",
      externalUserInfo: "External user info",
      copied: "Copied",
      copyError: "Error while copying",
      resendEmailToExternalUser:
        "Are you sure you want to resend the email to the external user?",
    },
    now: "Now",
    scheduleNew: "Schedule a new appointment",
    counsellors: "Student health staff",
    appointments: "Appointments",
    seeAll: "See all",
    notExist: "Appointment does not exist",
    weeksInterval: "In {{interval}} weeks",
    daysInterval: "In {{interval}} days",
    dayInterval: "In {{interval}} day",
    hoursInterval: "In {{interval}} hours",
    hourInterval: "In {{interval}} hour",
    minutesInterval: "In {{interval}} minutes",
    minuteInterval: "In {{interval}} minute",
    today: "Today",
    future: "Future",
    completed: "Completed",
    cancelled: "Cancelled",
    noAppointments: "No appointments here yet...",
    organizationNotWorking: "Organization is not working on this day",
    scheduleFirst: "Schedule your first appointment",
    yourFreeTime: "Your available time",
    freeTime: {
      title: "Your available time",
      addTime: "Add time",
      noFreeTimes:
        "Please allocate your available time in order students can book the appointments",
      allocateTime: "Allocate available time",
      editTime: "Edit available time",
      startTime: "Start time",
      endTime: "End time",
      add: "Add",
      cancel: "Cancel",
      date: "Date",
      ends: "Ends",
      orgNotWorking: "Organization is not working",
      repeats: {
        everyday: "Everyday",
        weeklyOn: "Weekly on {{day}}",
        weekdays: "Every weekday (Monday to Friday)",
        none: "Doesn't repeat",
      },
      deleteModal: {
        title: "Delete available time",
        description: "Are you sure you want to delete your available time?",
        delete: "Yes, Delete",
      },
      timeAdded: "Your available time was added",
      timeEdited: "Your available time was edited",
      timeDeleted: "Your available time was deleted",
    },
    customMeeting: "Choose appointment type",
    error: {
      studentOrCounsellor: "Student or staff unavailable between {{data}}",
      and: "and",
      counsellor: "Healthcare staff unavailable this time",
      timeError: "End-time must be greater than start-time",
      minimumTime: "Appointment must be greater than {{minimumTime}} minutes",
      currentTime: "Start-time must be greater than current-time",
      noAvailableTime: "Student or staff unavailable at this time",
    },
    invited: "{{count}} Invited",
    participants: "{{count}} Participants",
  },
  notes: {
    title: "Notes & reports",
    note: "Note",
    report: "Report",
    topics: "Topics",
    meetingType: "Meeting type",
    meetingKind: "Meeting place",
    meetingDuration: "Meeting duration",
    student: "Student",
    generated: "Generated",
    add: "Add note",
    personNotes: "{{person}}'s notes & reports",
    personNote: "{{person}}'s note",
    personReport: "{{person}}'s report",
    personStatistics: "{{person}}'s Statistics",
    create: "Create a note",
    saveText: "Take notes about the student.",
    autoSaveText:
      "Take notes about student. All notes will be saved automatically",
    autoSaveTextDuringVideo:
      "Take notes during the session. All notes will be saved automatically",
    metaAppointment:
      "{{person}} finished appointment with {{student}}, {{date}}",
    metaChat: "{{person}} finished chat with {{student}}, {{date}}",
    createdBy: "{{date}} by {{person}}",
    delete: "Delete note",
    deleteQuestion: "Are you sure you want to delete this note?",
    yes: "Yes, delete",
    saved: "The note has been saved",
    deleted: "The note has been deleted",
    worryLevel: "Worry level",
    filter: "Filter",
    notes: "Notes",
    reports: "Reports",
    isPinned: "Pin note",
    pinnedNotes: "This note is pinned",
    isNotPinned: "This note is not pinned",
    isPublic: "Open",
    isForPublic: "This note is visible for other professions",
    isNotForPublic: "This note is not visible for other professions.",
    publicLabel: "Open",
    pinnedLabel: "Pinned",
    isForReportPublic: "This report is visible for other professions",
    isReportNotForPublic: "This report is not visible for other professions",
  },
  videoCall: {
    leaveCallModal: {
      title: "Finishing the appointment",
      paragraph:
        "Already done with the appointment? If so, click End the call option and fill the report. If not, click Leave the call and you'll be able to rejoin it.",
      leaveCall: "Leave the call",
      endCall: "End the call",
    },
    videoAccessModal: {
      title: "Camera or microphone is blocked",
      description_1:
        "Allbry requires access to your camera and microphone. Click the camera blocked icon",
      description_2: "in your browser's address bar.",
      leaveCall: "Leave the call",
    },
    join: "Join",
    notJoin: "Not joined",
  },
  chat: {
    end: "End chat",
    archivedForCounsellor:
      "This chat has been archived by the student. To restart the conversation you just need to write something.",
    endInfoForCounsellor:
      "This chat was ended on {{time}} by you. To restart the conversation you just need to write something.",
    noMessages: "No messages here yet",
    sendFirstMessage: "Send your first message to {{person}}",
    writeMessage: "Write a message...",
    endChatQuestion:
      "Are you sure you want to end the chat? The chat will not be deleted, you can restart it by sending the message.",
    attachmentInfo: "{{fileSize}}, {{date}} at {{time}}",
    sharedFiles: "SHARED FILES",
    noFiles: "No shared files here yet..",
    general: "General",
    messages: "Messages",
    chatEnded: "(Chat ended)",
    attachment: "(Attachment)",
    image: "(Image)",
    startTitle: "Who you want to talk with?",
    noStudentsFound: "No students found",
    notFoundLabels: {
      student: "No student found",
      counsellor: "No student health staff found",
      globalCounsellor: "No global student health staff found",
    },
    noStudentsAvailable: "No students are available",
    noStudentsAvailableToChat:
      "There are no available students to start a chat with",
    noCounsellorsAvailable: "No student health staff are available",
    noCounsellorsAvailableToChat:
      "There are no available staff to start a chat with",
    start: "Start chat",
    startGroupChat: "Start group chat",
    nameTheGroupChat: "Name the group chat",
    enterGroupName: "Enter a name for group chat",
    groupName: "Name of group",
    more: "View more",
    selectChat: "Select a chat to start messaging",
    archive: "Archive",
    delete: "Delete chat",
    organizationDoesntWork:
      "Organization doesn't work now. It'll take longer time to receive the answer. We recommend to send messages at {{start}} - {{end}}",
    organizationDoesntWorkToday:
      "Organization is not working today. It'll take longer time to receive the answer",
    endInfoForStudent:
      "This chat was ended on {{time}} by {{person}}. To restart the conversation you just need to write something.",
    sendAfterWork: "Send message outside working hours",
    workingHours:
      "Working hours of organization: {{start}} - {{end}}. If you want to send message outside working hours, please note that you receive answer in working hours.",
    workingHoursToday:
      "Organization is not working today. If you want to send message outside working hours, please note that you receive answer in working hours.",
    ok: "Ok, got it",
    deleteChatQuestion: "Are you sure you want to delete the chat?",
    archiveChat: "Archive chat",
    unarchiveChat: "Unarchive chat",
    deleted: "Chat deleted",
    archived: "Chat archived",
    unarchived: "Chat unarchived",
    deleteGroup: "Delete group",
    modifyGroup: "Modify group",
    groupAllMembers: "Group Members",
    modifyGroupChat: "Modify group chat",
    editGroupName: "Enter a name for the group chat",
    members: "Participants",
    confirmToDelete: "Are you sure to delete this group?",
    confirmToDeleteMember: "Are you sure to remove selected participant?",
    addNewMember: "Add new participant",
    deleteSelected: "Delete selected participant",
    selectNewMember: "Select new participant",
    selectClose: "Select & close",
    noMembersInGroup:
      "There are no more participants in this group, Do you want to delete this group?",
    groupMembers: "{{value}} participants",
    overview: "Overview",
    notesAndReports: "Notes & reports",
    statistics: "Statistics",
    imageFile: "Image or file",
    akkImage: "AAC image",
    read: "Read",
    akk: {
      selectCategory: "Select Category",
      chooseAkk: "Choose images",
      send: "Send",
      noImage: "No images found",
    },
    all: "All",
    students: "Students",
    counsellors: {
      shortName: "Local",
      fullName: "Student health staff",
    },
    globalCounsellors: {
      shortName: "Global",
      fullName: "Global student health staff",
    },
    searchStudent: "Search student",
    searchCounsellor: "Search health staff",
    searchGlobalCounsellor: "Search global health staff",
    active: "Registered",
    inactive: "Inactive",
    deactivated: "Deactivated",
    successDelete: "Message deleted successfully",
    counsellorUnavailable: "Counsellor unavailable",
    videoCall: "Video Call",
    confirmVideoCall: "Are you sure you want to start a video call?",
    counsellorInactive: "Counsellor no longer works in this organization",
    onlyAllbryCanSendMessage: "Only {{name}} can send messages",
    messagesTitleSuperAdmin: "Messages (Tech releases)",
    showMore: "Show more",
  },
  reports: {
    createReport: "Create report",
    deleteReport: "Delete report",
    deleteReportQuestion: "Are you sure you want to delete the report?",
    yes: "Yes, delete",
    deleted: "The report has been deleted",
    title: "Reporting",
    title2: "Non mandatory step",
    selectDate: "1. Date",
    selectTopics: "2. Select the topic in the conversation",
    concernScale: "3. How worried are you about the student?",
    selectMeetingType: "4. What kind of meeting did you have?",
    selectMeetingKind: "5. How did the meeting occur?",
    noteComment: "{{questionNo}}. Note / Comment",
    feedbackAllbry:
      "{{questionNo}}. Is there anything else you want to be able to map? (optional market research)",
    additionalSupportQuestionTitle:
      "{{questionNo}}. Is the student in need of additional support?",
    participationThanks: {
      title: "Thank you!",
      details:
        "Thank you for providing this information. It's really helpful for us.",
      close: "Close",
    },
    topics: {
      startOfSession: "Start of the session",
      checkIn: "Check-in",
      basicCare: "Basic care",
      identity: "Identity",
      anxiety: "Anxiety",
      stress: "Stress",
      physicalHealth: "Physical health",
      training: "Training",
      crime: "Crime",
      sorrow: "Sorrow",
      socialRelationship: "Social relationship",
      workLife: "Work life",
      shame: "Shame",
      honor: "Honor",
      careFailure: "Child neglect",
      economy: "Economy",
      security: "Security",
      stimulationAndGuidance: "Stimulation and guidance",
      socialOrientation: "Social orientation",
      emotionalAvailability: "Emotional availability",
      love: "Love",
      mentalHealth: "Mental health",
      mentalAbuse: "Mental abuse",
      physicalAbuse: "Physical abuse",
      loveRelations: "Love relations",
      familyRelations: "Family relations",
      sexualAbuse: "Sexual abuse",
      economicalAbuse: "Financial abuse",
      drugUse: "Drug use",
      performanceAnxiety: "Performance anxiety",
      loneliness: "Loneliness",
      grooming: "Grooming",
      school: "School",
      education: "Education",
      selfHarm: "Self-injurious behavior",
      suicidalToughts: "Suicidal thoughts",
      religion: "Religion",
      politics: "Politics",
      sexuality: "Sexuality",
      npfDiagnoses: "NPF diagnoses",
    },
    meetingType: {
      emergencyMeeting: "Emergency meeting",
      dropInMeeting: "Drop-in meeting",
      individualMeeting: "Individual meeting",
      noShowMeeting: "No-show meeting",
      parentMeeting: "Meeting with guardian",
      ehtMeeting: "Meeting with representative from EHT",
      groupMeeting: "Group meeting with students",
      adultMeeting: "Meeting with other adult (i.e. teacher)",
      breakMeeting: "Meeting in hallway or during break",
      adultStudentMeeting:
        "Meeting with student, guardian, principal and / or other school staff",
    },
    meetingKind: {
      allbryMeeting: "Did you book or have the meeting in Allbry?",
      allbryMeetingIfNot: "If not, where did you have the meeting?",
      telephone: "Telephone meeting",
      digital: "Digital meeting",
      physical: "Physical meeting",
    },
    addTopic: {
      title: "Add topic",
      name: "Name",
      description: "Description",
      button: "Add new",
      success: "Topic added successfully",
      error: "Error while adding topic",
      expandTab: "Expand",
      collapseTab: "Collapse",
      all: "All",
    },
    worriedLevel: {
      level0: "No worry / contact sought",
      level0_5: "Risk on the way to level 1",
      level1: "Preventive / promotional / informative talk or other talks",
      level1_5: "Risk on the way to level 2",
      level2: "Mild worry – worry that you can manage with the student",
      level2_5: "Risk on the way to level 3",
      level3:
        "Medium concern - contact the school and follow-up after 4 weeks or refer to BUP / psychiatry & other instances",
      level3_5: "Risk on the way to level 4",
      level4: "High concern - ”orosanmälan” or similar",
      level4_5: "Risk on the way to level 5",
      level5:
        "Acute concern - act now, alert the emergency services or similar",
      details0:
        "No concern / contact sought \n\nNo concern at this stage. The student has sought contact or started a conversation.",
      details0_5: "Risk on the way to level 1",
      details1:
        "Preventive / promotional / informative talk or other talks \n\nAt this level, student health staff have had preventive / promotional / informative calls or other types of support calls. For example, about friendships, love, future and free time or goals and dreams and similar themes/topics.\n\nGuided conversations in connection with, for example, the high school application (for elementary school students) or the university application (for high school students).",
      details1_5: "Risk on the way to level 2",
      details2:
        "Mild concern - concern that you can manage with the student \n\nAt this level, student health personnel feel mild concern for the student. This means concern where the counsellor/student health staff and student can talk about topics/themes without having to notify others (duty of confidentiality). This may include conversations about self-esteem, self-confidence, past trauma, relationships and health, and experiences that the student is talking about.\n\nAt this stage of concern, the counselor/student health professional can use their skills, knowledge and conversational methods to work with the student and support at different times and situations. \n\nRelationship building, trust and confidence are important at this level as a student may tell something in confidence to the student health staff that the student does not want to reveal to anyone else but still needs help, an example is low self-esteem, tells about NPF diagnoses , investigations, previous contact with authorities such as social services and BUP or adult psychiatry.\n\nThere is a concern for the student but you as student health staff are there to support and sort out the concern.",
      details2_5: "Risk on the way to level 3",
      details3:
        "Medium concern - contact the school and follow-up after 4 weeks or refer to BUP / psychiatry & other agencies \n\nThis is the first step where student health personnel must act and violate confidentiality (non-disclosure). In this case, it is about contacting the school in case of concerns about the child's health (mental and physical health), school attendance, school results, home environment, ostracism and bullying. Offensive treatment. In the first step, a counselor or mentor is contacted. Possibly a case for EHT/EHM to discuss this student, for example in the case of adaptations, difficulties at school. Follow-up for the student takes place after 4 weeks, the counselor is responsible for follow-up.",
      details3_5: "Risk on the way to level 4",
      details4:
        "High concern - report of concern or similar \n\nBased on the National Board of Health and Welfare's governing document and notification obligation according to SoL 14 ch. 1§ & SkolL 29 ch. 13, obligation to report if you know or suspect that a child is in harm's way. Student health personnel notify the student (and the parents in some cases) and inform them that a report of concern is being made and why it is being made. The school must always be informed. A report of concern is usually made in collaboration with the principal.\n\nThe National Board of Health and Welfare's (2013) definition of the term ”children who get hurt” from Children who get hurt or are at risk of getting hurt. A guide for healthcare and dental care regarding reporting obligations and responsibilities.\n\n”The concept of child harm includes all forms of abuse, neglect and exploitation that lead to actual or potential damage to the child's health or development. It can, for example, refer to children and young people who are exposed to physical or psychological violence, sexual abuse, violations or problems in relation to their family, as well as if they witness violence or live in an environment where violence and threats of violence occur. It also includes children and young people who get hurt because of their own behavior, for example because of substance abuse, crime and other self-destructive behavior. Children who are exposed to threats, violence or other abuse from peers or from others, as well as children with major problems in the school situation caused by a social problem can also be considered to be part of the social service's target group. and exploitation that results in actual or potential harm to the child's health or development. It can, for example, refer to children and young people who are exposed to physical or psychological violence, sexual abuse, violations or problems in relation to their family, as well as if they witness violence or live in an environment where violence and threats of violence occur. It also includes children and young people who get hurt because of their own behavior, for example because of substance abuse, crime and other self-destructive behavior. Children who are exposed to threats, violence or other abuse from peers or from others, as well as children with major problems in the school situation caused by a social problem can also be considered part of the social services target group.”",
      details4_5: "Risk on the way to level 5",
      details5:
        "Urgent concern - act now, alert the emergency services or similar \n\nAct immediately. At this stage, there is immediate danger to the student's life or health, or other situations where action must be taken immediately. Call 112. Contact emergency services. It could be that a student writes that they will attempt suicide, commit a crime or put themselves or someone else in immediate danger. Acute concern - act now, alert the emergency services or the like \n\nAct immediately. At this stage, there is immediate danger to the student's life or health, or other situations where action must be taken immediately. Call 112. Contact emergency services. It could be that a student writes that they will attempt suicide, commit a crime or put themselves or someone else in immediate danger.",
      title: "Information level ",
    },
    types: {
      quick: {
        title: "Quick",
        description: "Only a limited number of subjects",
        selectTopics: "1. Select the topic in the conversation",
        selectMeetingKind: "2. How did the meeting occur?",
      },
      normal: {
        title: "Normal",
        description: "Full length report",
      },
    },
    additionalSupport: {
      youthReception: "Youth reception",
      socialServices: "Social services",
      medicalAndHealthcare: "Medical and healthcare",
    },
    statistics: {
      additionalSupport: "Additional support",
    },
  },
  principal: {
    validation: {
      notEmpty: "Value can't be empty",
      noSpaces: "Value can't have spaces",
      lessThan30Symbols: "{{value}} should be less than 30 symbols",
      exists: "Attribute already exists",
      ageLessThan8: "Your age cannot be less than 8",
      ageLessThan18: "Your age cannot be less than 18",
      required: "{{value}} is required",
      requiredName: "Name is required",
      requiredEmail: "Email is required",
      notValidEmail: "Not valid email",
    },
    addCustomField: "Add custom field",
    overview: "{{name}} Overview",
    schedule: "Organization schedule",
    addCustomAttributes: "Add custom attributes",
    customFieldsDescription:
      "While creating the user you'll see added custom fields.",
    anonymous:
      "Students in your organization are allowed to be anonymous. Their names and profile images will be hidden from other users.",
    removeChatTitle: "Remove chats",
    removeChatDescription:
      "Students in your organization are allowed to remove chats with student health staff.",
    archiveChatTitle: "Archive chats",
    archiveChatDescription:
      "Students in your organization are allowed to archive chats with student health staff.",
    to: "To",
    from: "From",
    workingHours: "Working hours",
    custom: "Custom",
    weekDays: "Weekdays",
    allDays: "All days",
    addCustomMeetingTypes: "Create custom appointment types",
    addMeetingType: "Create appointment type",
    createMeetingType: "Create appointment type",
    editMeetingType: "Edit appointment type",
    chooseMeetingTypeEN: "Choose name of appointment type in english",
    chooseMeetingTypeSW: "Choose name of appointment type in swedish",
    meetingDescriptionSW:
      "Enter a description for the appointment type in swedish",
    meetingDescriptionEN:
      "Enter a description for the appointment type in english",
    videoEnable: "Video enabled",
    meetingCreated: "Appointment type created successfully",
    errorCreateMeeting: "Error while create appointment type",
    updatedMeeting: "Updated appointment type successfully",
    errorUpdatingMeeting: "Error updating appointment type",
    removeMeeting: "Appointment type removed successfully",
    errorRemovingMeeting: "Error while removing appointment type",
    MeetingNameRequired: "Appointment type name is required",
    confirmRemoveMeeting: "Are you sure to remove appointment type",
    editMeeting: "Edit",
    removePopup: "Are you sure to remove appointment type?",
    video: "Video",
    appointmentTypeDescription:
      "The default Video meeting type will dissapear if a new video meeting type is added",
    sessionDuration: "Select meeting duration time",
    sessionDurationNote:
      "Note: Please make sure you make a selection. Because if no option is selected then the default options are 20 minutes and 50 minutes",
    days: {
      monday: "Monday",
      tuesday: "Tuesday",
      wednesday: "Wednesday",
      thursday: "Thursday",
      friday: "Friday",
      saturday: "Saturday",
      sunday: "Sunday",
    },
    startLaterThanEnd: "Start time is later than end time",
    endBeforeStart: "The end time is before the start time",
    edit: "Edit User",
    add: "Add User",
    student: "Student",
    counsellor: "Student health staff",
    allbryCounsellor: "Allbry Counsellor",
    userCreated: "The user was created successfully.",
    errorCreatingUser: "Error creating user",
    userUpdated: "The user was updated successfully.",
    errorUpdatingUser: "Error updating user",
    userTable: {
      viewProfile: "View profile",
      editProfile: "Edit profile",
      users: "users",
      active: "Registered",
      inactive: "Inactive",
      deactivated: "Deactivated",
      nameSurname: "Name Surname",
      birthday: "Date of birth",
      organization: "Organization",
      activate: "Activate",
      deactivate: "Deactivate",
      profileActivated: "Profile activated",
      profileDeactivated: "Profile deactivated",
      activatingError: "Error activating profile",
      deactivatingError: "Error deactivating profile",
      generateCsvTemplate: "Generate csv template",
      generateXlsxTemplate: "Generate xlsx template",
      importUsers: "Import users from xls or xlsx",
      csvImportTitle: "Import is in progress",
      csvImportBody:
        "Importing users may take some time. Please, don't close the window",
      importButton: "Import",
      selectFiles: "Select file to import",
      importTitle: "Import users",
      usersAddSuccess: "Users successfully added",
      usersAddError: "Error in importing users",
      wrongFormat: "File format should be xls or xlsx",
      wrongImportData: "Error in row {{row}}:\n{{error}}",
      validationError: "{{field}} ✑ {{error}}",
      onboardingEmailDialogInstruction:
        "You will send onboarding emails to the following users",
      inActivateMultipleUserDialogInstruction:
        "You will deactivate the following users",
      scrapeMultipleUserDialogInstruction:
        "You will scrape the following users",
      sendEmail: "Send Email",
      onboardingEmail: "Onboarding Email",
      customEmail: "Custom Email",
      disableStudent: "Disable Students",
      disableUser: "Disable Users",
      actions: "Actions",
      role: "Role",
      class: "Class",
      usersDelete: "Delete users",
      requestScrapeSuccess:
        "Request for Scrape Multiple Users submitted successfully",
      changeAttributesSuccessMessage: "Attributes changed successfully",
      changeAttributes: "Change attributes",
      deactivatedSuccessMessage: "Users deactivated successfully",
    },
    csv: {
      custom: "Fill custom attribute",
      email: "Fill person's email",
      role: "Fill number: 1 - student, 2 - counsellor",
      gender: "Fill number: 1 - male, 2 - female, 3 - other",
      year: "Year of birth",
      month: "Month of birth (number)",
      day: "Day of birth",
      nameSurname: "Fill person's name and surname",
      dateOfBirth: "Date of birth: yyyymmdd",
      fillNumber: "Fill number",
      workSheetName: "Sheet1",
    },
    csvFields: {
      custom: "Custom attribute",
      email: "Email",
      role: "Role",
      gender: "Gender",
      year: "Year of birth",
      month: "Month of birth",
      day: "Day of birth",
      nameSurname: "Name and surname",
      dateOfBirth: "Date of birth",
      fillNumber: "Fill number",
      workSheetName: "Sheet1",
      attribute: "Attribute",
    },
    csvFieldsValidationMessages: {
      dateOfBirth: "Date of birth must be in the format yyyymmdd",
      dateOfBirthRequired: "Date of birth is required",
      attributeRequired: "{{attributes}} is required",
      nameSurnameInvalid: "Name is invalid",
    },
    usersOrganization: "{{name}} Users",
    addUserButton: "Add user",
    about: "About me",
    user: {
      role: "Role",
      email: "Email",
      status: "Status",
      forcePassword: "Force Password",
      attribute: "Attribute",
      attributeDescription:
        "You can select multiple attributes here. \n\nStudents with atleast one of the selected attribute will be able to contact you. However you can always concats everybody.\nIf you do not select any attributes, all students can see you.",
      forcePasswordDescription:
        "If you select this option, the user will be forced to change their password on the first login.",
      allbryCounsellor: " Allbry Counsellor",
    },
    enterFieldName: "Enter Field name (E.x. Class)",
    result: "{{value}} result",
    results: "{{value}} results",
    noResults: "No results",
    day: "Day",
    month: "Month",
    year: "Year",
    statistic: {
      title: "Statistics",
      calendar: "Calendar",
      today: "Today",
      last7Days: "Last 7 days",
      last30Days: "Last 30 days",
      last90Days: "Last 90 days",
      thisWeek: "This Week",
      thisMonth: "This month",
      thisQuarter: "This quarter",
      thisYear: "This year",
      allTime: "All time",
      userTypes: "User types",
      notFound: "No statistics found",
      topics: "Student reports",
      amountOfReports: "Amount of reports",
      experience: "Experience",
      counselling: "Appointments",
      popularTimes: "Popular hours",
      ngoClicks: "Support lines",
      usersAmount: "{{amount}} users",
      levelOfWorry: "Level of worry",
      chats: "Chats",
      video: "Video",
      other: "Other",
      appointments: "Appointments",
      all: "All",
      without0: "Actual worry level",
      without0tooltip:
        "Enabled: Average level of worry is shown for the meetings where a concern has actually been indicated. \nDisabled: Average level of worry for all meetings is displayed even where worry was not experienced.",
      allTitle: {
        users: "{{value}} users",
        user: "{{value}} users",
        times: "{{value}} times",
        time: "{{value}} times",
        zero: "0",
        redirection: "{{value}} redirection",
        redirections: "{{value}} redirection",
      },
      registered: "Registered",
      inactive: "Inactive",
      active: "Registered & active",
      todayInterval: "Today {{start}} - {{end}}",
      pdfExport: "Export as PDF",
      chartTitle: "Counselling",
      student: "Student statistics",
      internal: "Internal EHT statistics",
      totalHours: "Total hours of reports",
      showAll: "Show all",
      showLess: "Show less",
      anonymousUsersCount: "Amount of anonymous users - {{count}}",
      selectTopicsCategories: "Select topics categories",
      includeMeetingKind: "Include Manual reports",
      moreThanOneChatCountAverage:
        "Average number of chats for students that chatted more than once:",
      oneChatCountPercentage: "Number of students that only chatted once:",
    },
    internalStatistic: {
      time: "Time spent per group",
      total: "Total",
      hours: "hours",
    },
    changeAttributesNotes:
      '- If you want to change attributes select and show the input box to write your change, then press the "Save" button to save the changes attributes. \n - If you only select attributes and press the "Save" button, you will attribute delete. \n - If you want to add a new attribute, write your new attribute, then press the "Save" button to save the new attribute. ',
  },
  admin: {
    title: "Allbry Admin",
    modals: {
      addCounsellors: {
        choose: "Choose student health staff",
        search: "Search student health staff",
      },
    },
    organization: {
      organizations: "organizations",
      edit: "Edit organization",
      details: "Organization details",
      closed: "Closed",
      start: "Start Date",
      end: "End Date",
      principal: "Principal",
      principals: "Principals",
      create: "Create organization",
      view: "View",
      editPopup: "Edit",
      deactivated: "Organization deactivated",
      deactivatedError: "Error deactivating organization",
      name: "Organization Name",
      startEnd: "Start date/End date",
      addPrincipal: "+ Add principal",
      addCounsellor: "+ Add student health staff",
      searchOrganizations: "Search organizations by name",
      edited: "The organization was edited successfully.",
      created: "The organization Was created successfully.",
      createdError: "Error creating organization",
      editError: "Error editing organization",
      longName: "Too long name",
      startDateRequired: "Start date is required",
      endBeforeStart: "End date cannot be before start date",
      longEmail: "Too long email",
      emailFormat: "Wrong email format",
      duplicateEmails: "Duplicate emails",
      userExists: "User already exists",
      atLeastOne: "At least one must be active",
      subscriptionType: {
        title: "Subscription types",
        description:
          "Your organization  bla bla description for the feature allows you to be anonymous. Your name and profile image will be hidden from other users",
        addLink: "+ Add feature or type",
        selectType: "Select type",
        registrationCode: "Registration code",
        add: "Add",
        remove: "Remove",
        addDialogTitle: "Add subscription type",
        addSuccess: "Subscription type has been added successfully",
        removeSuccess: "Subscription type has been removed successfully",
      },
      deleteOrganization: "Delete organization",
      requestScrapeSuccess:
        "Request for Scrape Multiple Organizations submitted successfully",
      scrapeMultipleOrganizationDialogInstruction:
        "You will scrape the following organizations",
    },
    role: {
      title: "Roles",
      addRoles: "+ Add role",
      createRole: "Create role",
      editRole: "Edit role",
      chooseMasterRole: "Choose master role",
      enterNameRoleSwedish: "Enter name of role swedish",
      enterNameRoleEnglish: "Enter name of role english",
      chooseFeatures: "Choose features",
      selectMasterRole: "Select master role",
      customRolesCreated: "Custom role created successfully",
      errorCreatecustomRoles: "Error while create custom role",
      updatedcustomRoles: "Updated custom role successfully",
      errorUpdatingcustomRoles: "Error updating custom role",
      removecustomRoles: "Custom role removed successfully",
      errorRemovingcustomRoles: "Error while removing custom role",
      confirmRemovecustomRoles: "Are you sure to remove custom role?",
      rolesRequired: "Roles required",
      rolesSelectRequired: "Select atleast one role",
      chooseFeaturesOne: "Choose atleast one feature",
      sessionTimeRequired: "Session time required",
      sessionTimeNumber: "Session time should be number",
      sessionTimeMin: "Session time should be greater than 1 hour",
      sessionTimeTitle: "Session time",
    },
    counsellors: {
      title: "Allbry Counsellors",
      add: "Add counsellor",
      edit: "Edit counsellor",
      profile: "Counsellor's profile",
      searchCounsellors: "Search counsellors by name",
    },
    ftpDataCollection: {
      title: "FTP Data Collection",
      selectOrganizations: "Select Organization",
      runCron: "Run Now",
      cronRunStart:
        "Data migration process started for the selected organization. You will be received an email shortly",
    },
    configData: {
      title: "Config Data",
      addConfig: "Add Config",
      organization: "Organization",
      migrationTime: "Migration Time",
      status: "Status",
      active: "Active",
      deactivate: "Deactivated",
      viewProfile: "View Config",
      editProfile: "Edit Config",
      organizationActivated: "Organization Activated",
      organizationDeactivated: "Organization Deactivated",
      activatingError: "Error activating Organization",
      deactivatingError: "Error deactivating Organization",
      configDetails: "{{organization}}'s Config Details",
      timerNotSet: "Timer Not Set",
      yes: "Yes",
      no: "No",
    },
    configForm: {
      title: "Config Form",
      addOrgConfig: "Add organization Config",
      editOrgConfig: "Edit organization Config",
      ftpConfigDetails: "FTP Config Details",
      organization: "Organization",
      runOnce: "Run Single Time",
      timer: "Timer",
      daily: "Every Midnight",
      weekly: "Every Sunday Midnight",
      monthly: "Every 1st Of Month Midnight",
      selectTimer: "Select Timer",
      subOrganization: "Sub Organization",
      addOrganization: "+ Add Organization",
      selectOrganizations: "Select Organization",
      userModel: "User Models",
      addModel: "+ Add Model",
      student: "Student",
      attribute: "Attribute",
      userAttributes: "User Attribute",
      addAttribute: "+ Add Attribute",
      selectAttributes: "Select Attribute",
      name: "Name",
      code: "Code",
      host: "Host Name",
      username: "Username",
      password: "Password",
      port: "Port",
      secure: "Secure",
      fileName: "File Name",
      fileFormat: "File Format",
      filePath: "File Path",
      true: "True",
      false: "False",
      fileNameEx: 'Ex: File name is "latest" or create \nyour custom file name',
      filePathEx: 'Ex: File path is "/"  ',
      userModelNameEx: 'Ex: name is "student/counsellor"',
      userModelCodeEx: 'Ex: code is "student/counsellor"',
      edit: "Edit Config",
      nameRequired: "Name is required",
      codeRequired: "Code is required",
      selectRequired: "Select any one",
      configRequired: "{{name}} is required",
    },
    notifications: {
      notificationDate: "Notification Date",
      message: "Message",
      activeInactive: "Active/Inactive",
      status: "Status",
      all: "All",
      sent: "Sent",
      upcoming: "Upcoming",
      vieweditNotifications: "View/edit notifications",
      deleteNotifications: "Delete notifications",
      createNotification: "Create notification",
      notificationDateAndTime: "Notifications date and time",
      notificationMessage: "Notification Message",
      notificationMessagePlaceholder: "Enter notification message",
      allOrganization: "All Organization",
      selectOrganization: "Select Organization",
      add: "Add",
      popup: "Are you sure to remove notification?",
      messageValidation: "Message can not be blank",
      selectRequired: "Select at least one organization",
      createdNotification: "Notification create successfully",
      removedNotification: "Notification removed successfully",
      editNotification: "Notification edit successfully",
      errorCreateNotification: "Error while creating notification",
      errorErrorNotification: "Error while edit notification",
    },
    superActions: {
      title: "Super Actions",
      userLoginWithEmail: "User login with email",
      loginButton: "Login",
      emailInput: "Email",
    },
    broadcastMessages: {
      createdBroadcastMessage: "Broadcast message create successfully",
      updatedBroadcastMessage: "Broadcast message updated successfully",
      removedBroadcastMessage: "Broadcast message removed successfully",
      deleteBroadcastMessageConfirmation:
        "Are you sure you want to delete this record ?",
      deleteBroadcastMessageError:
        "You cannot delete this record but can deactivate it",
      editBroadcastMessage: "Broadcast message edit successfully",
      errorCreateBroadcastMessage: "Error while creating broadcast message",
      errorUpdateBroadcastMessage: "Error while updating broadcast message",
      errorRemoveBroadcastMessage: "Error while removing broadcast message",
      allOrganizations: "All Organizations",
      selectOrganization: "Select Organization",
      active: "Active",
      inActive: "Inactive",
      edit: "Edit",
      delete: "Delete",
      create: {
        startDate: "Start Date",
        endDate: "End Date",
        enterHeading: "Enter Heading",
        message: "Enter Message",
        newsAndMarketingMessage: "News and Marketing Message",
        add: "Add",
        heading: "Heading",
        userTypes: "User Types",
        selectUserTypes: "Select User Type",
      },
      userTypes: {
        counsellor: "Counsellor",
        student: "Student",
      },
      listingColumn: {
        heading: "Heading",
        message: "Message",
        startDate: "Start Date",
        endDate: "End Date",
        userType: "User Type",
        status: "Status",
      },
    },
  },
  allbryCounsellor: {
    choose: "Choose organization",
    notFound: "No organization found...",
    text: "You haven't been added to any organization yet.",
    error: "Error while attempting to login in organization",
  },
  filterModal: {
    filter: "Filter",
    addFilter: "Add filter",
    description: "Show users that match all conditions:",
    addCondition: "+ Add condition",
    is: "is",
    isNot: "is not",
    chooseFilter: "Choose filter",
    conditionValue: "Enter condition value",
  },
  counsellorReport: {
    tabs: {
      reportTemplates: "Report templates",
      reports: "Reports",
      customReports: "Custom reports",
    },
    reports: "Reports",
    reportTemplate: {
      studentReport: "Student report",
      studentReportDescription: "Create a student report",
      studentNote: "Student note",
      studentNoteDescription: "Create a student note",
      internalReport: "Internal EHT report",
      internalReportDescription: "Create a internal EHT report",
      anonymousReport: "Anonymous student report",
      anonymousReportDescription: "Create an anonymous student report",
    },
    internalReport: {
      selectTypes: "2. Select the type of meeting",
      selectFilter: "3. Select group if applicable (non mandatory)",
      meetingDuration: "5. Meeting duration (in hours)",
      meetingNotes: "4. Meeting notes",
      meetingNoteTitle: "Anteckningar",
      meetingTypes: {
        type1: "EHT",
        type2: "EHM",
        type3: "Cooperation meeting SIP",
        type4: "Cooperation meeting with VH, students & other actors",
        type5: "Cooperation meeting BUP",
        type6: "Meeting with VH, students & other actors",
        type7: "Meeting with student and VH",
        type8: "Meeting with VH",
        type9: "Meeting with student and school staff",
        type10: "Meeting with VH and another actor",
        type11: "Meeting cooperation",
        type12: "Attendance work",
        type13: "Guiding school staff",
        type14: "Meeting with school staff",
        type15: "Meeting with principal",
        type16: "Participation in development work",
        type17: "Participation in security work",
        type18: "Work with student groups",
      },
      staticAttributes: {
        attributeName: {
          attribute1: "Stage",
        },
        attributeValue: {
          attribute1value1: "Low stage",
          attribute1value2: "Middle stage",
          attribute1value3: "High stage",
          attribute1value4: "High school",
        },
      },
    },
    anonymousReport: {
      title: "Anonymous student report",
      selectAttributeTitle: "1. Select class/year (non mandatory)",
      noAttributes:
        "No attributes found. Please contact your administrator to add attributes.",
      gender: "2. Gender identity (non mandatory)",
      studentName: "3. Enter students name (non mandatory)",
    },
    chooseStudent: "Choose student",
    chooseCustomStudent: "Choose {{label}}",
    createReport: "Create report",
    createNote: "Create note",
    searchStudents: "Search students",
    filterOption: {
      notes: "Notes",
      quickReport: "Student reports",
      internalReport: "Internal reports",
      anonymousReport: "Anonymous reports",
    },
    showMore: "Show more...",
  },
  survey: {
    introStep: "Hey, let's start with a quick survey",
    firstStep: {
      question: "Have you tried Allbry before?",
      letMeIn: "Yes, let me in!",
      whatIsAllbry: "What is Allbry?",
    },
    secondStep: {
      question: "Have you previously sought guidance?",
      yes: "Yes, a couple of times",
      never: "No, I haven't",
    },
    genderStep: {
      question: "To which gender do you most identify?",
      male: "Male",
      female: "Female",
      other: "Other",
      private: "Do not wish to say",
    },
    outroStep: "Thank you for your time!",
    helpImprove:
      "It'll take only few minutes, but will help us to improve your experience with Allbry.",
    firstPart: "1/2",
    secondPart: "2/2",
    page: "Page",
    checkInAndSurvey: "Check-ins and Surveys",
    tabOption: {
      template: "Templates",
      active: "Active",
      statistics: "Statistics",
    },
    create: {
      title: "Template creator",
      name: "Name",
      accessType: "Access type",
      accessTypeOptions: {
        global: "Global",
        local: "Local",
      },
      surveyType: "Survey type",
      surveyTypeOptions: {
        checkIn: "Check-in",
        survey: "Survey",
      },
      isPublic: "Is Public",
      isActive: "Is Active",
    },
    createConfig: {
      title: "Config Templates",
      Survey: "Survey Template",
      Account: "Organization",
      attributes: "User Attributes",
      select: "-Select-",
      runsDay: "Runs every Day",
      runsWeekly: "Runs every",
      runsMonthly: "Runs every {{date}} th of month",
      timerOption: {
        daily: "Daily",
        weekly: "Weekly",
        monthly: "Monthly",
        weekDays: {
          monday: "Monday",
          tuesday: "Tuesday",
          wednesday: "Wednesday",
          thursday: "Thursday",
          friday: "Friday",
          saturday: "Saturday",
          sunday: "Sunday",
        },
      },
      modals: {
        students: {
          title: "Select Group",
          chooseStudentTitle: "Who do you want to check on?",
          selectedStudents: "Selected Students",
          confirmSelection: "Confirm Selection",
          searchPlaceholder: "Search for students",
          noStudentsFound: "No students found",
        },
      },
      addOwnUsers: "+ Add your own users",
      addedOwnUsers: "Added {{count}} own users",
    },
    template: {
      createTemplate: "Template create successfully",
      errorCreateTemplate: "Error while creating template",
      deleteTemplate: "Template delete successfully",
      deleteTemplateConfirmation:
        "Are you sure you want to delete this templates ?",

      deleteTemplateError:
        "You cannot delete this template but can deactivate it",
      deleteConfigError: "You cannot delete this config but can deactivate it",
      errorDeleteTemplate: "Error while deleting template",
      editTemplate: "Template edit successfully",
      errorEditTemplate: "Error while editing template ",
      createConfig: "Config create successfully",
      errorCreateConfig: "Error while creating config",
      active: "Active",
      inActive: "Inactive",
      true: "Yes",
      false: "No",
      timer: "Timer",
      RunOnce: "RunOnce",
      StartTime: "Start time",
      EndTime: "End time",
      TimeLimitInHour: "Time limit in Hour",
      typeChangeDescription:
        "We are looking you have some changes on survey Templates.\n Are you sure you want to change?\n If you change the survey type then you all changes will be discard.",
      btn: {
        delete: "Delete",
        edit: "Edit",
        statistics: "Statistics",
        addImage: "Add image to question",
      },
      listingColumn: {
        name: "Name",
        accessType: "Access type",
        surveyType: "Survey type",
        public: "Public",
        questionAmount: "Question amount",
        status: "status",
      },
      listingColumn: {
        name: "Name",
        templateName: "Template Name",
        accessType: "Access type",
        surveyType: "Survey type",
        public: "Public",
        questionAmount: "Question amount",
        status: "Status",
        attributes: "User Attributes",
        organization: "Organization Name",
        isAnonymous: "Is Anonymous",
        action: "Action",
        StartDate: "Start Date",
        EndDate: "End Date",
      },
      questionType: {
        filling: "Feelings",
        rangSlider: "Range slider",
        singleSelect: "Single select",
        image: "Image",
      },
      createTemplateAboutDescription:
        "Watch the video below to learn more about the template creator.",
      createTemplateAboutTitle: "Description",
      duplicate: "Duplicate",
      copyText: "Copy",
      addImages: "Add images",
    },
    student: {
      question: "Question",
      stripMas: "Your teacher wants to take the test!",
      questionnaire: "The school questionnaire",
      completeHeading: "Thanks for your answers!",
      completeDescription: "The school questionnaire has been submitted.",
      completeBackButton: "Back to home screen",
      startSurvey: "Start the survey",
      skipQuestion: "I do not want to answer",
      SkipMas: "Are you sure, you don't want to answer?",
      notAnonymousAnswerDescription:
        "The survey is not anonymous, and the student health services can access individual responses",
    },
    statistics: {
      noAnyTemplate: "You have no any templates",
      all: "All",
      ended: "Ended",
      started: "Started",
      date: "Date",
      AmountOfAnswers: "Amount of answers",
      noOFUsers: "No. of users",
      question: "question",
      thisMonth: "This month",
      unanswered: "Unanswered",
      status: {
        new: "New",
        complete: "Complete",
        active: "Active",
      },
      showAll: "Show all",
      showLess: "Show less",
      response: "response",
      days: "Days",
      weekNumbers: "Week numbers",
      months: "Months",
      students: "Students",
      noAnyoneAnswered: "No students have answered this survey",
      answer: "Answer",
      deepFilter: "Deep filter",
      averageValue: "Average value: {{value}}",
      multiple: "(Multiple)",
      guestUserLink: "Guest user link",
      showGuestUserData: "Show guest user data",
      filterInfo: "If a filter is applied, remove the guest user data.",
      guestUsers: "guest users",
      showGuestUserDataDisabledContent:
        "Not possible to show guest user data if a filter is applied.",
      amountOfCustomStudents: "Manually chosen students",
      numberOfCustomStudents: "Number of manually chosen students",
      anonymousResponse: "Response #{{number}}",
      responses: "Responses",
    },
    counsellor: {
      titles: { survey: "Survey", checkIn: "Check in" },
      readMoreDifferenceModalTitle: "Difference",
      checkInDescription:
        "A recurring survey with questions asked at regular intervals according to a selected time interval. It is used to continuously collect data, identify trends and track changes over time. Perfect for measuring student well-being or other factors that require regular follow-up. By analyzing the results over time, insights can be created that contribute to better decision-making and long-term development.",
      surveyDescription:
        "A one-time survey with questions asked at a specific time. It is used to quickly gather information, evaluate an event, or get a snapshot of student opinions and experiences. It is well suited for safety and health surveys, school surveys, or evaluations where a single data collection is sufficient. The results can provide valuable insights for making decisions or improving future processes.",
      title: "The Temperature check",
      startTitle: "Pace your students",
      startDescription:
        "With the temperature check, you can send out long or short questionnaires to learn more about the well-being of your students.",
      createTemplateBtn: "Create your first temp",
      addTemplateBtn: "Create new temp",
      readMoreDifference: "Read more about the difference",
      student: "Students",
      ownSelection: "Own selection",
      ownSelectionDescription: "Select individuals",
      answered: "Answered",
      dispatch: "Dispatch frequency",
      adjustTime: "Adjust date and time",
      question: {
        num1: "Do you want to take the test or create a survey?",
        template: "What do you want to tempt?",
        attribute: "Which ones do you want to challenge?",
        survey: "How often do you want to take the temp?",
        checkIn: "When do you want to send out the survey?",
        description: {
          checkIn:
            "Survey with uestions that are asked regularly during a selected interval",
          survey: "Survey with questions asked once",
        },
        anonymousPageTitle: "Do you want to see individual answers?",
        anonymousPageDescription:
          "If you activate this, you will be able to see students individual answers, however the student will be informed when starting the survey that their answers will not be anonymous",
        guestPageTitle: "Do you want to generate a anonymous link?",
        guestPageDescription:
          "If you activate this, you will receive a link and/or QR-code that you can distribute to students. \n The students who then use the link will be able to answser the survey without logging in and/or having an account.",
      },
      status: {
        active: "Active",
        search: "Search",
        completed: "Completed",
      },
      timerOption: {
        daily: "Daily",
        weekly: "Weekly",
        monthly: "Monthly",
        dailyDescription: "Shipped every day",
        weeklyDescription: "Shipped every Monday",
        monthlyDescription: "Sent on the 1st of every month",
      },
      createOwnTemplate: "+ Create your own template",
    },
    templateType: {
      general: "General",
      private: "Private",
    },
    surveyTypeOptions: {
      checkIn: "Check-in",
      survey: "Survey",
    },
    amountQuestion: "Amount of questions",
    endSurveyConfig: "End survey",
    endSurveyPopupConfirmationText:
      "Are you sure you want to stop this survey?",
    endSuccess: "Survey ended successfully",
    deleteSurveyConfig: "Delete survey",
    deleteSurveyConfigPopupConfirmationText:
      "Are you sure you want to delete this survey and its statistics?",
    editorLabels: {
      designer: "Designer",
      preview: "Preview",
    },
    creator: {
      title: "Survey title",
    },
  },
  customReports: {
    title: "Custom Reports",
    description:
      "Here you can choose to activate and/or create your own report templates if you find that something is missing from our existing ones. Just like with the student report, graphs and statistics are generated based on the responses provided by the staff. You can also choose to create an anonymous report where none of the students' responses can be traced back to them.",
    createReportBtn: "Create a custom report",
    template: {
      title: "Template creator",
      type: {
        general: "General",
        private: "Private",
      },
      duplicate: "Duplicate",
      copyText: "Copy",
      name: "Name",
      namePlaceholder: "Please enter name",
      description: "Description",
      descriptionPlaceholder: "Please enter description",
      accessTypeLabel: "Access type",
      accessTypePlaceholder: "Please select access type",
      accessType: {
        global: "Global",
        local: "Local",
      },
      public: "Public",
      active: "Active",
      createTemplateAboutTitle: "Description",
      createTemplateAboutDescription:
        "Watch the video below to learn more about the template creator.",
      createTemplateSuccess: "Template create successfully",
      errorCreateTemplate: "Error while creating template",
      updateTemplateSuccess: "Template update successfully",
      errorUpdateTemplate: "Error while updating template",
      deleteTemplateConfirmation:
        "Are you sure you want to delete this template?",
      createTemplateSecretLevelConfirmationLow:
        "Are you sure you want to activate the report with a low confidentiality level?",
      createTemplateSecretLevelConfirmationHigh:
        "Are you sure you want to activate the report with a high confidentiality level?",
      createTemplateSecretLevelDescription:
        "The following roles will have access to this report type: {{description}}",
      deleteTemplateSuccess: "Template delete successfully",
      errorDeleteTemplate: "Error while deleting template",
      confirmDialog: {
        editTemplate: {
          header: "Are you sure you want to edit this template?",
          body: "If you edit the template...",
        },
      },
    },
    statistics: {
      selectTemplate: "Select template",
      users: "Users",
      allReports: "All reports",
      normalReport: "Normal report #{{number}}",
      anonymousReport: "Anonymous report #{{number}}",
      resultAdditionalInfo: {
        dateAndTime: "Date and time",
        user: "User",
        reporter: "Reporter",
      },
    },
    config: {
      screen1: {
        title: "Choose template or create your own",
        createTemplate: "Create your own template",
      },
      screen2: {
        title: "Roles with access",
        person: "{{count}} person",
        persons: "{{count}} persons",
      },
      screen3: {
        title: "Do you want to allow anonymous reports?",
        allowAnonymousReportsDescription:
          "If you activate this, users will be able to create anonymous reports. This means that staff will not need to select a student when using the report.",
      },
      screen4: {
        title: "Choose confidentiality level",
        allowPriorityDescription:
          "You need to select a confidentiality level for the report type you have created. The selected level determines how the reports can be shared within the staff group. <br><br> A high confidentiality level restricts access to individual student responses and only provides anonymized statistics to staff roles not explicitly granted access. Free-text responses are entirely hidden, as they may contain identifiable information. This level is suitable when sensitive information should only be handled by specific professional roles. <br><br> A low confidentiality level means that the entire staff group can access complete reports, including individual responses and the names of the students concerned. Free-text responses are also visible, which increases transparency but requires careful handling of personal data.",

        highPriorityDescription:
          "A high confidentiality level means that individual reports are not visible to all staff members. Only the professional roles selected in the previous step will have access to individual responses. Other staff members will only see aggregated statistics, with no link to specific students. Additionally, no statistics will be shown for free-text questions, as these may include identifying information.",

        lowPriorityDescription:
          "A low confidentiality level means that all staff members have access to individual responses in the reports, including which students the reports refer to. This means there are no restrictions on which professional roles can view the content. Free-text responses are also visible, which may include personally identifiable information. This level may be suitable in situations where the entire team needs full insight in order to provide appropriate support.",
        high: "High",
        low: "Low",
      },
      createSuccess: "Config create successfully",
      errorCreateConfig: "Error while creating config",
      updateSuccess: "Config update successfully",
      errorUpdateConfig: "Error while updating config",
      list: {
        all: "All",
        reports: "{{count}} Reports",
      },
      amountOfQuestions: "Amount of questions",
      amountOfReports: "Amount of reports",
      roles: "Roles",
      editRoles: "Edit roles",
      editTemplate: "Edit template",
      rolesUpdateSuccess: "Roles update successfully",
      errorRolesUpdate: "Error while updating roles",
      warningDialogForNotEligibleToEditTemplate: {
        header: "You are not eligible to edit this template",
        body: "You can not edit this template because you are not eligible to edit this template. Please contact your administrator.",
      },
    },
  },
};

export default en;
